import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {numberOnly} from '../bin/common';
import {useMutation} from '@tanstack/react-query';
import {getId, smsCert, smsSend} from '../library/api';

const FindId = () => {
    const navigate = useNavigate();
    const [isIdResult, setIsIdResult] = useState(false);
//현장 정보를 가져오는데 실패하였습니다. 다시 시도해 주세요
    const [value, setValue] = useState({name: '', phone: '', certKey: ''});
    const [valueCheck, setValueCheck] = useState({phone: false, certKey: false});

    // 문자 전송
    const {mutate: smsSendMutate} = useMutation({
        mutationFn: smsSend,
        mutationKey: ['smsSend'],
        onSuccess: data => {
            if (data.done) {
                alert('인증번호가 전송되었습니다');
                setValueCheck(prevState => ({...prevState, phone: true, certKey: false}));
                setTimeout(() => {
                    if (valueCheck.certKey === false) {
                        setValue(prevState => ({...prevState, certKey: ''}));
                        setValueCheck(prevState => ({...prevState, phone: false, certKey: false}));
                    }
                }, 180000);
            }
        },
        onError: error => {
            alert(error.response.data.message);
            throw error;
        }
    });

    // 문자 인증번호 인증
    const {mutate: smsCertMutate} = useMutation({
        mutationFn: smsCert,
        mutationKey: ['smsCert'],
        onSuccess: data => {
            if (data.done) {
                alert('인증이 완료 되었습니다');
                setValueCheck(prevState => ({...prevState, certKey: true}));
            } else {

            }
        },
        onError: error => {
            alert(error.response.data.message);
            throw error;
        }
    });

    // 아이디(이메일) 블러오기
    const {mutate: getIdMutate, data: getIdData} = useMutation({
        mutationFn: getId,
        mutationKey: ['getId'],
        onSuccess: data => {
            if (data.id !== null) {
                setIsIdResult(true);
            }
        },
        onError: error => {
            alert(error.response.data.message);
            throw error;
        }
    });


    const handleSubmit = (event) => {
        event.preventDefault();

        if (!value.name) {
            alert('이름을 입력해주세요');
            return;
        }


        if (!value.phone) {
            alert('휴대폰 번호를 입력해주세요');
            return;
        }

        if (!valueCheck.phone) {
            alert('휴대폰 번호 인증해주세요');
            return;
        }
        if (!value.certKey) {
            alert('인증번호를 입력해주세요');
            return;
        }
        if (value.certKey.length < 6) {
            alert('인증번호를 확인해주세요');
            return;
        }
        if (!valueCheck.certKey) {
            alert('인증번호를 인증해주세요');
            return;
        }

        getIdMutate({
            phoneNum: value.phone,
            certNum: value.certKey,
            partnersNm: value.name
        });

    };
    return (
        <main className="flex-grow container mx-auto px-4 py-10 sm:py-20">
            <div className="max-w-md mx-auto">
                <h1 className="text-3xl sm:text-4xl font-extrabold text-center mb-2">아이디 찾기</h1>
                {
                    isIdResult ? <>
                        <p className="text-center text-sm mb-8 sm:mb-10">요청하신 아이디 찾기 결과입니다.</p>
                        <div
                            className="flex flex-col items-center justify-center gap-y-[50px] border border-gray-300 rounded-[10px] p-[50px] md:w-[500px]">
                            <img src="./assets/find-id.svg"/>
                            <p className="text-[#333333] text-center">
                                <b>{value.name}</b>님의 아이디는
                                <br/>
                                <span
                                    className="text-teal-500 font-medium text-[22px] underline underline-offset-2"> {getIdData?.id}</span>입니다.
                            </p>
                            <button onClick={() => navigate('/login')}
                                    className="rounded-[30px] w-[166px] h-[60px] bg-teal-500 font-extrabold text-[20px] text-white">로그인
                            </button>
                        </div>
                    </> : <>
                        <p className="text-center text-sm mb-8 sm:mb-10">아이디를 찾기 위해 회원정보를 입력해주세요.</p>
                        <form id="loginForm" className="flex flex-col items-center mb-6" onSubmit={handleSubmit}>
                            <div className="mb-2.5 w-full">
                                <input type="text" placeholder="이름"
                                       className="w-full px-4 py-3 sm:py-4 border border-gray-300 rounded-lg outline-none"
                                       onChange={e => {
                                           setValue(prevState => ({...prevState, name: e.target.value}));
                                       }}/>
                                <p className="text-[#F22F2F] text-sm font-medium mt-3 mb-4">이름(실명)을 정확히 입력해주세요.</p>
                            </div>
                            <div className="mb-2.5 w-full">
                                <div className="flex gap-x-[10px]">
                                    <input type="text" placeholder="휴대폰번호" maxLength="12" onChange={event => {
                                        numberOnly(event);
                                        setValue(prevState => ({...prevState, phone: event.target.value, certKey: ''}));
                                        setValueCheck(prevState => ({...prevState, phone: false, certKey: false}));
                                    }}
                                           className="w-full px-4 py-4 border border-gray-300 rounded-lg outline-none"/>
                                    <button
                                        className={`w-40  text-white py-4 rounded-lg ${valueCheck.phone ? 'bg-regal-blue' : 'bg-teal-500'}`}
                                        onClick={e => {
                                            e.preventDefault();
                                            if (!value.phone) {
                                                alert('휴대폰 번호를 입력해주세요');
                                                return;
                                            }
                                            smsSendMutate(value.phone);
                                            //   setValueCheck(prevState => ({...prevState, phone: true, certKey: false}));
                                        }}>
                                        인증번호 전송
                                    </button>
                                </div>
                            </div>
                            <div className="mb-14 w-full">
                                <div className="flex gap-x-[10px]">
                                    <input type="text" placeholder="인증번호 6자리를 입력해주세요" value={value.certKey}
                                           maxLength="6"
                                           onChange={event => {
                                               numberOnly(event);
                                               setValue(prevState => ({...prevState, certKey: event.target.value}));
                                               setValueCheck(prevState => ({...prevState, certKey: false}));
                                           }}
                                           className="w-full px-4 py-4 border border-gray-300 rounded-lg outline-none"/>
                                    <button
                                        className={`w-40  text-white py-4 rounded-lg ${valueCheck.certKey ? 'bg-regal-blue' : 'bg-teal-500'} `}
                                        onClick={e => {
                                            e.preventDefault();

                                            if (!value.phone) {
                                                alert('휴대폰 번호를 입력해주세요');
                                                return;
                                            }

                                            if (!valueCheck.phone) {
                                                alert('휴대폰 번호를 인증해주세요');
                                                return;
                                            }
                                            if (!value.certKey) {
                                                alert('인증번호를 입력해주세요');
                                                return;
                                            }
                                            if (value.certKey.length < 6) {
                                                alert('인증번호를 확인해주세요');
                                                return;
                                            }
                                            smsCertMutate({phone_numb: value.phone, cert_numb: value.certKey});
                                            // setValueCheck(prevState => ({...prevState, certKey: true}));
                                        }}>
                                        인증하기
                                    </button>
                                </div>
                            </div>
                            <button type="submit"
                                    className="w-full bg-teal-500 font-extrabold text-lg text-white py-3 sm:py-4 rounded-full hover:bg-teal-600 transition duration-300">
                                <a>아이디 찾기</a>
                            </button>
                        </form>
                        <div className="flex justify-between items-center">
                            <p className="mt-1 text-base font-medium">비밀번호를 재설정하시나요?</p>
                            <button
                                className="px-3 py-2 border border-gray-400 rounded-lg text-base font-medium text-gray-400"
                                onClick={() => navigate('/find-pw')}>비밀번호 재설정
                            </button>
                        </div>
                    </>
                }

            </div>

        </main>
    );
};

export default FindId;
